import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '../../../dronebee-ui';

const LogoutModal = ({ logout, isOpen, toggle }) => (
  <Modal
    size='sm'
    ctaFunction={() => {
      logout();
      toggle();
    }}
    onHide={toggle}
    title={'Logout'}
    isOpen={isOpen}
    cancelButton
    ctaButton
    ctaText={'Logout'}
  >
    <p className='mb-0 me-3'>You will be logged out of the system.  If you have any unsaved changes, they will be lost.  Are you sure you want to log out?</p>
  </ Modal>);

LogoutModal.propTypes = {
  logout: PropTypes.func,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
};

export default LogoutModal;
